import React from 'react';
import { Autocomplete, Checkbox, TextField, InputAdornment } from '@mui/material';
import { CheckBoxOutlineBlankOutlined, CheckBox, FilterList } from '@mui/icons-material';

function Filter({ options, value, onSelect, label, placeholder, multiple = false, width='50%' }) {
    return (
        <Autocomplete 
            multiple={multiple}
            options={options}
            disableCloseOnSelect={multiple}
            getOptionLabel={(option) => option}
            value={value || (multiple ? [] : '')}
            onChange={(event, newValue) => onSelect(newValue)}
            renderOption={(renderProps, option, { selected }) => (
                <li {...renderProps}>
                    <Checkbox
                        icon={<CheckBoxOutlineBlankOutlined fontSize='small' />}
                        checkedIcon={<CheckBox fontSize='small' />}
                        style={{ marginRight: 8 }}
                        checked={selected}
                    />
                    {option}
                </li>
            )}
            style={{ width: width, backgroundColor: 'white' }}
            renderInput={(params) => (
                <TextField 
                    {...params}
                    label={label} 
                    placeholder={placeholder}
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                            <InputAdornment position='start'>
                                <FilterList />
                            </InputAdornment>
                        )
                    }}
                />
            )}
        />
    )
}

export default Filter;